import { useContext, useState } from 'react'
import { useLocation, useRouteMatch } from 'react-router-dom'
import { openModal } from './Modal'
import { DesignContext } from 'contexts/DesignContext'
import objectPath from 'object-path'
import ModalComponent from 'designer/component/component/Modal'
import useAuth from 'hooks/useAuth'
import { InputGroup } from 'react-bootstrap'
import Icon from '../Icon'
import { Tooltip } from '@mui/material'
import { cancelDebounceCallback } from 'utility/debounceCallback.util'

const IconActionWrapper = ({
  config = {},
  uischema,
  iconName,
  isReadOnly = false,
  border,
  modalOpenSource,
}) => {
  const { dynamicName, dynamicKey, dynamicIndex } = config
  const designContext = useContext(DesignContext)
  const {
    jsonForm,
    setOpenModal,
    setIsInputSearch,
    isUiChanged,
  } = designContext
  const isOpenModal = designContext.openModal
  let { action } = uischema
  const { user } = useAuth()
  const match = useRouteMatch()
  const location = useLocation()
  const search = location.search || []
  const receivePathParams = match.params
  const urlSearchParams = new URLSearchParams(search)
  const receiveQueryParams = Object.fromEntries([...urlSearchParams])
  const allParams = { ...receivePathParams, ...receiveQueryParams }
  let formData = objectPath.get(jsonForm, 'formData') || {}
  let designerPropsData = objectPath.get(jsonForm, 'designerPropsData') || {}
  let designerData = objectPath.get(designerPropsData, 'data') || {}
  let systemData = jsonForm.systemData
  let rowData = objectPath.get(jsonForm, 'componentPropsData.rowData')
  let datasourceValue = objectPath.get(designContext, `@datasource`) || {}
  let data = {
    formData,
    allParams,
    user,
    datasourceValue,
    designerData,
    systemData,
    rowData,
  }

  let modalFieldKey = `${dynamicName}.${dynamicIndex}`
  let dynamicModal = objectPath.get(isUiChanged, [uischema.key, 'dynamicModal'])
  let isSameDynamic = dynamicKey ? modalFieldKey === dynamicModal : true
  let cursor = isReadOnly ? {} : action?.modalType ? { cursor: 'pointer' } : {}

  const onOpenModal = () => {
    if (isReadOnly) return
    if (!action) return
    if (modalOpenSource === 'inputAppend') {
      cancelDebounceCallback('onInputUpdate')
      setIsInputSearch && setIsInputSearch(false)
    }
    if (dynamicKey) {
      objectPath.set(isUiChanged, [uischema.key, 'dynamicModal'], modalFieldKey)
    }
    openModal({
      action,
      data,
      designContext,
      uischema,
      setOpenModal,
    })
  }

  return (
    <>
      <InputGroup.Text
        style={{ ...cursor, ...border }}
        className={`px-2 text-secondary d-flex h-100 ${
          isReadOnly ? '' : 'bg-white'
        }`}
        onClick={onOpenModal}
      >
        <span className="px-1 ">
          <Icon iconName={iconName} />
        </span>
      </InputGroup.Text>
      {isOpenModal === uischema.key && isSameDynamic && (
        <ModalComponent
          {...config}
          config={config}
          ui={uischema}
          modalAction={action}
          isOpenModal={isOpenModal === uischema.key && isSameDynamic}
          designerPropsData={jsonForm.designerPropsData}
          modalDynamicIndex={dynamicIndex}
          modalOpenSource={modalOpenSource}
        />
      )}
    </>
  )
}

const Overlay = (props) => {
  let { iconTooltip } = props

  if (!iconTooltip) return <IconActionWrapper {...props} />

  return (
    <Tooltip
      title={<span style={{ fontSize: '14px' }}>{iconTooltip}</span>}
      arrow
    >
      <span style={{ cursor: 'pointer' }}>
        <IconActionWrapper {...props} />
      </span>
    </Tooltip>
  )
}

export default Overlay
